import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { tpoGenUrls } from 'config/urls';
import { tpoGenKeys } from '../../../utils/tpoGenQueryKeys';
import { sendNotification } from 'utils/helperMethods';

const deleteEvent = async (eventId: string) => {
    const token = localStorage.getItem('accessToken');
    const response = await axios(tpoGenUrls.deleteEvent(eventId), {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
};

const useDeleteEventMutation = ({ onSuccess }: { onSuccess?: () => void } = {}) => {
    const queryClient = useQueryClient();

    const { mutate, isPending } = useMutation({
        mutationFn: (eventId: string) => deleteEvent(eventId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: tpoGenKeys.all });
            queryClient.invalidateQueries({ queryKey: ['calendarData'] });
            sendNotification('success', 'Event deleted successfully');
            onSuccess?.();
        },
        onError: (error: any) => {
            const message = error?.response?.data?.message || error?.message || 'Failed to delete event';
            sendNotification('error', message);
        },
    });

    return { mutate, isPending };
};

export default useDeleteEventMutation;
